var TorsoView = require('backbone-torso/modules/View');
var onsiteDetailsPerspectiveTemplate = require('./onsiteDetailsPerspectiveTemplate.hbs');
var OnsiteDetailsView = require('./OnsiteDetailsView');

/**
 * Perspective for Onsite Details Layout
 *
 * @class OnsiteDetailsPerspective
 */
module.exports = TorsoView.extend({
  template: onsiteDetailsPerspectiveTemplate,
  moduleNamespace: 'onsiteDetailsPerspective',

  injectionSites: {
    'content-view': '_contentView'
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient to display the appointments for.
   *   @param options.appointmentExternalId {String} the external id of the appointment to display
   *   @param options.isExpressCheckin {Boolean} whether or not this perspective is for express checkin
   * @override
   */
  initialize: function(options) {
    options = options || {};
    this._contentView = new OnsiteDetailsView({
      patientVecnaId: options.patientVecnaId,
      appointmentExternalId: options.appointmentExternalId,
      isExpressCheckin: options.isExpressCheckin
    });
  }
});
